<script>
  import { navigate } from "svelte-routing";

  export let path;
  export let active;
  export let style = "normal"; // "normal" | "dynamic"
</script>

<button class:active on:click={() => path && navigate(path)} class:dynamic={style === "dynamic"}
  ><slot /></button>

<style lang="scss">
  button {
    @apply opacity-50 px-2 text-white border-b border-transparent;

    &:hover {
      @apply opacity-100;
    }

    &.dynamic {
      @apply italic;
      &.active {
        @apply border-blue-400;
      }
    }

    &.active {
      @apply opacity-100 border-b-white;
    }
  }
</style>
